// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__alnAj","disabled":"Switch_disabled__MDFDX","slider":"Switch_slider__TjH3X"};